// extracted by mini-css-extract-plugin
module.exports = {"redButton":"LoginButtons2-module--redButton--3M1uf"};